/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiFilterSortALowToHighIcon16Light } from './UiFilterSortALowToHighIcon16Light';
import { UiFilterSortALowToHighIcon16Regular } from './UiFilterSortALowToHighIcon16Regular';
import { UiFilterSortALowToHighIcon16Solid } from './UiFilterSortALowToHighIcon16Solid';
import { UiFilterSortALowToHighIcon20Light } from './UiFilterSortALowToHighIcon20Light';
import { UiFilterSortALowToHighIcon20Regular } from './UiFilterSortALowToHighIcon20Regular';
import { UiFilterSortALowToHighIcon20Solid } from './UiFilterSortALowToHighIcon20Solid';
import { UiFilterSortALowToHighIcon24Regular } from './UiFilterSortALowToHighIcon24Regular';
import { UiFilterSortALowToHighIcon24Solid } from './UiFilterSortALowToHighIcon24Solid';
import { UiFilterSortALowToHighIcon32Regular } from './UiFilterSortALowToHighIcon32Regular';
import { UiFilterSortALowToHighIcon64Regular } from './UiFilterSortALowToHighIcon64Regular';
var sizes = {
    16: {
        light: UiFilterSortALowToHighIcon16Light,
        regular: UiFilterSortALowToHighIcon16Regular,
        solid: UiFilterSortALowToHighIcon16Solid,
    },
    20: {
        light: UiFilterSortALowToHighIcon20Light,
        regular: UiFilterSortALowToHighIcon20Regular,
        solid: UiFilterSortALowToHighIcon20Solid,
    },
    24: {
        regular: UiFilterSortALowToHighIcon24Regular,
        solid: UiFilterSortALowToHighIcon24Solid,
    },
    32: {
        regular: UiFilterSortALowToHighIcon32Regular,
    },
    64: {
        regular: UiFilterSortALowToHighIcon64Regular,
    },
};
export var UiFilterSortALowToHighIcon = forwardRef('UiFilterSortALowToHighIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
